import { CardMenu } from '@halo/ui-chat-react';

export function AudioOperate({
  value,
  children,
  onClick,
  items,
  container,
}: {
  children: React.ReactNode;
  value?: string;
  onClick: (value: string) => void;
  items: Array<{ key: string; label: React.ReactNode; disabled?: boolean }> | undefined;
  container?: React.RefObject<HTMLDivElement | null>;
}) {
  return (
    <CardMenu
      value={value}
      onClick={onClick}
      data={items || []}
      placement="top"
      itemProps={{
        justifyContent: 'center',
      }}
      container={container}
    >
      {children}
    </CardMenu>
  );
}

export default AudioOperate;
